import React from 'react';
import xero from '../../../../../img/icons/xero_logo.png';
import myob from '../../../../../img/icons/myob_logo.png';
import quickbook from "../../../../../img/icons/quickbooks_logo.png";
import connect_img from '../../../../../img/icons/FMB_icon6.svg'

const NotConnectedCard = ({ onConnectClick }) => (
  <div className="card">
    <div className="card-body">
      <div className="row">
        <div className="col-8 col-lg-12 m-auto text-center">
          <h5 className="font-weight-bold mt-2">Sync Your Accounting Software</h5>
            <img width={320} height={320} src={connect_img} />
          <p className="mt-2">
            Say goodbye to manual data entry and bulk uploads!
           Connect your accounting software and watch all your invoices flow seamlessly into your dashboard — automatically and effortlessly.</p>
          <p className="mt-2">
            <img width={50} height={50} src={xero} alt="Xero Logo" />
            <img className="ml-4" width={50} height={50} src={myob} alt="MYOB Logo" />
            <img className="ml-4" width={50} height={50} src={quickbook} alt="Quickbooks Logo" />
          </p>
          <div>
          
          </div>
          <div className="mb-2 mt-2">
            <button 
              className="btn btn-sm btn-primary ml-2" 
              onClick={onConnectClick}
              >
              Connect Now
            </button>
            <p className='mt-2 mb-2' ><small className='text-xs text-danger'>Click the 'Connect Now' button to request to connect to your accounting software platform.</small></p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default NotConnectedCard;
